const brand = process.env.NEXT_PUBLIC_BRAND;

// eslint-disable-next-line import/no-dynamic-require
const Logo = require(`./Logo.${brand}`).default;

export default Logo;
